import util from "@/common/util";
import service from "./service";

// 프로젝트 필터 목록 조회
function getFilterData(payload) {
  try {
    const res = service.getFilterData(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 사용자 리스트 호출
function getUserList(payload) {
  try {
    const res = service.getUserList(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}
// 사용자 비밀번호 초기화
function resetPassword(payload) {
  try {
    const res = service.resetUserPassword(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 지급 목록 조회
function getPaymentList(payload) {
  try {
    const res = service.getPaymentList(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}
// 지급 예정일 일괄 변경
function setPaymentDate(payload) {
  try {
    const res = service.setPaymentDate(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}
// 지급 상태 일괄 변경
function setPaymentStatus(payload) {
  try {
    const res = service.setPaymentStatus(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 사용자 추가
function createUser(payload) {
  try {
    const res = service.createUser(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 사용자 삭제
function deleteUser(payload) {
  try {
    const res = service.deleteUser(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

// 사용자 목록 다운로드
function getUserListExcel(payload) {
  return new Promise((resolve, reject) => {
    service
      .getUserListExcel(payload)
      .then((res) => {
        const name = "Studio_사용자목록" + util.datetimeFormat(new Date());
        const ext = `.${payload.fileType}`;
        const filename = name + ext;
        const result = downloadExcel(res, filename);
        resolve(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
// 지급 목록 다운로드
function getPaymentListExcel(payload) {
  return new Promise((resolve, reject) => {
    service
      .getPaymentListExcel(payload)
      .then((res) => {
        const name = "정산_리스트_" + util.datetimeFormat(new Date());
        const ext = `.${payload.fileType}`;
        const filename = name + ext;
        const result = downloadExcel(res, filename);
        resolve(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// 상세 정산내역 다운로드
function getPaymentDetailExcel(payload) {
  return new Promise((resolve, reject) => {
    service
      .getPaymentDetailListExcel(payload)
      .then((res) => {
        //const { projectName, userName, paymentType, date } = payload;
        const name = `${payload.projectName}_${payload.participantName}_${payload.participantType}_${payload.amountDate}`;
        const ext = `.${payload.fileType}`;
        const filename = name + ext;
        const result = downloadExcel(res, filename);
        resolve(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
function downloadExcel(res, filename) {
  const blob = new Blob([res.data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  link.style.cssText = "display: none";
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export default {
  getFilterData,
  getUserList,
  createUser,
  deleteUser,
  resetPassword,
  getUserListExcel,
  getPaymentList,
  getPaymentListExcel,
  getPaymentDetailExcel,
  setPaymentDate,
  setPaymentStatus,
};
